import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { AppHistory } from "@faire/retailer-visitor-shared/packages/core/services/AppHistory";
import { PreloadedImageTracker } from "@faire/retailer-visitor-shared/views/product/preload/PreloadedImageTracker";
import { trackProductInfoProductpagevideodetailsView } from "@faire/web-api--source/events/productInfo/view/productpagevideodetails";
export function trackPreloadedImageGrid(imageGridElement, pdpShowVerticalImagery) {
    var _AppHistory_get_previousLocation;
    if (AppHistory.get().history.action === "POP") {
        // Don't track PDP navigations triggered by back or forward.
        // There is be no opportunity for preloading in this case,
        // and images are likely still in the cache from the previous visit anyway.
        return;
    }
    var _AppHistory_get_previousLocation_pathname;
    var previousPath = (_AppHistory_get_previousLocation_pathname = (_AppHistory_get_previousLocation = AppHistory.get().previousLocation()) === null || _AppHistory_get_previousLocation === void 0 ? void 0 : _AppHistory_get_previousLocation.pathname) !== null && _AppHistory_get_previousLocation_pathname !== void 0 ? _AppHistory_get_previousLocation_pathname : "";
    var imgElements = Array.from(imageGridElement.querySelectorAll("img"));
    Promise.all(imgElements.map(waitForImageLoad)).then(function(imgs) {
        var _comparePreloadedUrls = comparePreloadedUrls(imgs.map(function(img) {
            return img.currentSrc;
        })), summaryString = _comparePreloadedUrls.summaryString, counts = _comparePreloadedUrls.counts, differences = _comparePreloadedUrls.differences;
        trackProductInfoProductpagevideodetailsView("V5_" + summaryString, JSON.stringify(_object_spread_props(_object_spread({}, counts), {
            pdpShowVerticalImagery: pdpShowVerticalImagery
        })), [
            previousPath
        ].concat(_to_consumable_array(differences)).join("|"));
    });
}
export function comparePreloadedUrls(urls) {
    var results = urls.map(function(url) {
        return findPreloadedUrl(url);
    });
    var counts = {
        preloadDiffers: 0,
        noPreload: 0,
        success: 0,
        showVerticalImagery: 0
    };
    var differencesSet = new Set();
    results.forEach(function(result) {
        if (result.type === "NO_PRELOAD") {
            counts.noPreload += 1;
        } else {
            if (result.type === "SUCCESS") {
                counts.success += 1;
            }
            if (result.type === "PRELOAD_DIFFERS") {
                counts.preloadDiffers += 1;
                differencesSet.add(result.differences);
            }
            if (result.showVerticalImagery) {
                counts.showVerticalImagery += 1;
            }
        }
    });
    return {
        summaryString: getSummaryString(results),
        counts: counts,
        differences: Array.from(differencesSet)
    };
}
function waitForImageLoad(img) {
    return new Promise(function(resolve) {
        function onLoadOrError() {
            img.removeEventListener("load", onLoadOrError);
            img.removeEventListener("error", onLoadOrError);
            resolve(img);
        }
        img.addEventListener("load", onLoadOrError);
        img.addEventListener("error", onLoadOrError);
    });
}
function findPreloadedUrl(currentSrc) {
    var match = PreloadedImageTracker.get().getInfo(currentSrc);
    if (match == null) {
        return {
            type: "NO_PRELOAD"
        };
    }
    var differences = currentSrc !== match.img.currentSrc ? JSON.stringify(diffUrls(match.img.currentSrc, currentSrc)) : "";
    return {
        type: differences ? "PRELOAD_DIFFERS" : "SUCCESS",
        differences: differences,
        showVerticalImagery: match.showVerticalImagery
    };
}
function diffUrls(urlStrA, urlStrB) {
    if (urlStrA === urlStrB) {
        return [];
    }
    var urlA;
    var urlB;
    try {
        urlA = new URL(urlStrA);
        urlB = new URL(urlStrB);
    } catch (e) {
        return [
            [
                "invalid URL",
                undefined
            ]
        ];
    }
    var mapFromQueryString = function(search) {
        return new Map(search.split("&").map(function(str) {
            return [
                str.split("=", 1)[0],
                str
            ];
        }));
    };
    var mapA = mapFromQueryString(urlA.search);
    var mapB = mapFromQueryString(urlB.search);
    var keySet = new Set(_to_consumable_array(mapA.keys()).concat(_to_consumable_array(mapB.keys())));
    var diffPairs = [
        [
            urlA.origin,
            urlB.origin
        ],
        [
            urlA.pathname,
            urlB.pathname
        ]
    ];
    keySet.forEach(function(key) {
        diffPairs.push([
            mapA.get(key),
            mapB.get(key)
        ]);
    });
    return diffPairs.filter(function(param) {
        var _param = _sliced_to_array(param, 2), a = _param[0], b = _param[1];
        return a !== b;
    });
}
function getSummaryString(results) {
    var types = new Set(results.map(function(r) {
        return r.type;
    }));
    if (types.size === 0) {
        return "ZERO_COUNT";
    } else if (types.size === 1 && types.has("SUCCESS")) {
        return "ALL_SUCCESS";
    } else if (types.size === 1 && types.has("NO_PRELOAD")) {
        return "ALL_NO_PRELOAD";
    } else if (types.size === 2 && types.has("NO_PRELOAD") && types.has("SUCCESS")) {
        return "ALL_SUCCESS_OR_NO_PRELOAD";
    } else if (types.has("PRELOAD_DIFFERS")) {
        return "SOME_DIFFER";
    } else {
        return "UNKNOWN";
    }
}
